import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LiraLazySlotBelowAdView } from '@/client/components/Adv/Lira/LiraLazySlotBelowAdView';
const LiraContainer = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LiraLazySlotBelowAdView />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const AdsAdDetailsBlock = function (t0) {
  const $ = _c(3);
  const {
    isMobile,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== isMobile) {
    t1 = isMobile ? <LiraContainer /> : <div className={classNames("adsense-bottom-container", className)} style={{
      margin: "20px",
      width: "620px"
    }}><LiraContainer /></div>;
    $[0] = className;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};